/**
 * @author Johann Esneider Casallas Becerra
 * @Copyright (c) Infotrack. All rights reserved.
 */

export default {
    // Alertas Maximos y Minimos

    'maximosMinimos.inputAlerta.nombreProducto': 'The Product Name field is empty. Please check the information',
    'maximosMinimos.inputAlerta.valorMinimoInvalido': 'Minimum value must be greater than zero, please verify the information',
    'maximosMinimos.inputAlerta.valorMaximoInvalido': 'Maximum value must be greater than zero, please verify the information',
    'maximosMinimos.inputAlerta.valorMinimoMayor': 'Minimum value cannot be greater than maximum value',

    // Gestion Maximos Minimos

    'maximosMinimos.CodigoProducto': 'Product Code',
    'maximosMinimos.agregarMaximosMinimos': 'Add Maximums and Minimums',
    'maximosMinimos.editarMaximosMinimos': 'Edit Maximums and Minimums',
    'maximosMinimos.NombreProducto': 'Product Name',
    'maximosMinimos.NivelMinimo': 'Minimum Level',
    'maximosMinimos.NivelMaximo': 'Maximum Level',
};
